import { useEffect } from 'react';
import {
  Form as FormContainer,
  useFormDispatch,
  useFormSelector
} from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';
import { useDatetime } from '../datetime/datetime-provider';
import { useCreateCalendarEventMutation } from '../google-calendar/use-create-calendar-event.mutation';
import { BOOKING_HIDDEN_FIELDS } from './fields';
import { FormLayout } from './form-layout';
import { useBookingHiddenFields } from './use-booking-hidden-fields';

export function Form() {
  const { t } = useLingui();

  const {
    widgetToken,
    integrationSettingsID,
    defaultFields,
    fields: customFields,
    afterBookingAction,
    afterBookingRedirectUrl
  } = useSettings();

  const { setSelectedTimeslot } = useDatetime();

  const { mutate: createGCEvent } = useCreateCalendarEventMutation();

  const dispatch = useFormDispatch();
  const { status } = useFormSelector();

  const onFormSubmit = () => {
    createGCEvent();
    if (afterBookingAction === 'redirect' && afterBookingRedirectUrl) {
      window.open(afterBookingRedirectUrl, '_self');
      setSelectedTimeslot(undefined);
    }
  };

  // Для сброса формы при изменении afterBookingAction
  useEffect(() => {
    if (status === 'success' && afterBookingAction === 'redirect') {
      dispatch({ type: 'reset' });
      setSelectedTimeslot(undefined);
    }
  }, [afterBookingAction, status, dispatch, setSelectedTimeslot]);

  useBookingHiddenFields();

  const fields = [...BOOKING_HIDDEN_FIELDS, ...defaultFields, ...customFields]
    .filter((field) => field.visible !== false)
    .map((field) => ({
      ...field,
      label: field.label
    }));

  const formSettings = {
    fields,
    integrationSettingsID,
    widgetToken,
    submitAdditionalData: {
      type: meta.appAlias
    },
    webhooks: []
  };

  return (
    <FormContainer
      {...formSettings}
      onSubmitSuccessful={onFormSubmit}
      consentValues={[t`Yes`, t`No`]}
    >
      <FormLayout displayedFields={fields} formSettings={formSettings} />
    </FormContainer>
  );
}

/*
  I18N FIX
 */

// Form Builder:
// t(`This field is required`)
